import * as z from 'zod';

import { systemUserQuerySchema } from '@/_pages/system-users/shared';

const auditEventSchema = z.union([z.literal('created'), z.literal('view'), z.literal('updated'), z.literal('deleted')]);
const auditableTypeSchema = z.union([
  z.literal('agreement'),
  z.literal('client'),
  z.literal('company'),
  z.literal('competitor'),
  z.literal('contact'),
  z.literal('domain'),
  z.literal('project'),
  z.literal('team-member'),
  z.literal('product'),
  z.literal('inventory'),
  z.literal('conference-event'),
  z.literal('agreement-deliverable'),
  z.literal('api-key'),
]);

export type AuditableTypeSchema = z.infer<typeof auditableTypeSchema>;

export type AuditEventSchema = z.infer<typeof auditEventSchema>;

export const auditQuerySchema = z.object({
  id: z.number(),
  user_type: z.string(),
  user_id: z.number(),
  event: auditEventSchema,
  auditable_type: auditableTypeSchema,
  auditable_id: z.number(),
  old_values: z.array(z.unknown()),
  new_values: z.array(z.unknown()),
  ip_address: z.string(),
  user_agent: z.string(),
  tags: z.string().nullable(),
  created_at: z.string(),
  updated_at: z.string(),
  user: systemUserQuerySchema,
});

export type AuditQuerySchema = z.infer<typeof auditQuerySchema>;

export const auditQueryAllSchema = z.object({
  data: z.array(auditQuerySchema),
  links: z.object({
    first: z.string().nullable(),
    last: z.string().nullable(),
    next: z.string().nullable(),
    prev: z.string().nullable(),
  }),
  meta: z.object({
    current_page: z.number(),
    from: z.number(),
    last_page: z.number(),
    path: z.string(),
    per_page: z.number(),
    to: z.number(),
    total: z.number(),
    links: z.array(
      z.object({
        url: z.string().nullable(),
        label: z.string(),
        active: z.boolean(),
      })
    ),
  }),
});

export type AuditQueryAllSchema = z.infer<typeof auditQueryAllSchema>;
